import WorkspaceSectionLayout from '../../components/WorkspaceSectionLayout';

const IntegrationsLayout = () => (
  <WorkspaceSectionLayout
    eyebrow="Integrations"
    title="Integrations"
    description="Payments and WhatsApp live in Manage and Messages. More connectors will show up here later."
    ariaLabel="Integrations"
  />
);

export default IntegrationsLayout;
